import Common from '../../../Common';
import Attempt from '../entry/Attempt';
import Log from './entry/Log';

interface Body {
	data: [{
		key: string
		value: string
	}]
}

const Entry = class extends Common {
	attempt: InstanceType<typeof Attempt>;
	log: InstanceType<typeof Log>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.attempt = new Attempt(headers)
		this.log = new Log(headers)
	}

	browse = (destinationId: id) => this.get(`/callback/destination/${destinationId}/entry`)
	create = (destinationId: id, body: Body) => this.post(`/callback/destination/${destinationId}/entry`, body)
}

export default Entry
